<template>
  <div id="home">
    <div class="header-view">
      <custom-header></custom-header>
    </div>

    <div class="content-view">
      <div class="sidebar-menu">
        <sidebar-menu></sidebar-menu>
      </div>

      <div class="route-view">
        <!-- router-view 路由出口 -->
        <!-- 路由匹配到的组件将渲染到这里 -->
        <div class="route-container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import header from "../components/common/header";
import sidebarMenu from "../components/common/menu";
export default {
  name: "App",
  components: {
    sidebarMenu,
    "custom-header": header,
  },
  computed: {
    ...mapState(["menuCollapse"]),
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/common";
#home {
  display: flex;
  flex-direction: column;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  min-width: 1280px;
  width: 100%;
  height: 100%;
  background-color: #f1f2f5;
  box-sizing: border-box;

  .header-view {
    height: 70px;
  }

  .content-view {
    width: 100%;
    display: flex;
    position: relative;
    height: calc(100% - 70px);
  }

  .sidebar-menu {
    width: 200px;
    height: 100%;
  }

  .route-view {
    box-sizing: border-box;
    position: relative;
    width: calc(100% - 200px);
    height: 100%;
    // flex: 1; 不能用flex
  }

  .route-container {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    // background-color: #fff;
    border-radius: 3px;
    // padding: 20px;
    overflow: auto;
    box-shadow: 0px 2px 4px 0px rgba(0, 21, 41, 0.12);

    /*滚动条样式*/
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 3px;
      -webkit-box-shadow: inset 0 0 5px #a0a0a0;
      background: #a0a0a0;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px #f5f5f5; /*轨道边框颜色*/
      border-radius: 0;
      background: #f5f5f5;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/ms-homePage.vue